// @ts-nocheck

const wordpressUI = (): void => {
  wp.domReady(() => {
    wp.blocks.unregisterBlockStyle('core/image', 'default');
    wp.blocks.unregisterBlockStyle('core/image', 'rounded');
  });
};

export default wordpressUI;
